// Records the type and client-side dispatch time of a chosen subset of
// actions. Layout.next_joke() reads and clears this when the player solves
// a joke and moves on to the next one, sending the batch to the backend.
const LOGGED_ACTION_TYPES = new Set(['HINT_CLICKED', 'WORD_PLACED_SUCCESS', 'NEXT_JOKE']);

let log = [];

export const actionLogger = store => next => action => {
  if (LOGGED_ACTION_TYPES.has(action.type)) {
    log.push({
      action_type: action.type,
      client_timestamp: new Date().toISOString(),
    });
  }
  return next(action);
};

export const getActionLog = () => log;

export const clearActionLog = () => {
  log = [];
};
